import {Component, OnInit, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Tax} from '../tax';
import {TaxService} from '../tax.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, MessagesModule} from "primeng/primeng";
import {Http} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {RecordDataComponent} from "../../../../components/record-data";
import {AppArcComponent} from "../../../../components/app-arc";
import {OrganizationShowComponent} from "../../organization/organization-show/organization-show.component";
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";
import {CurrencyMaskModule} from "ng2-currency-mask";



@NgModule({
    imports: [CommonModule, FormsModule, MessagesModule,MyInputsModule,CurrencyMaskModule,
        ReactiveFormsModule, ConfirmDialogModule, TranslateModule.forChild()
    ],
    declarations: [
        TaxesShowComponent
    ],
    entryComponents: [
        TaxesShowComponent
    ],
    exports: [],
    providers: [SharedService, TaxService, MessageService, ConfirmationService],
    schemas: [NO_ERRORS_SCHEMA]
})

@Component({
    selector: 'app-taxes-show',
    templateUrl: './taxes-show.component.html',
    styleUrls: ['./taxes-show.component.scss'],
    providers: [TaxService, ConfirmationService, MessageService]
})

export class TaxesShowComponent implements OnInit, AfterViewInit {
    id: string;
    tax = new Tax();
    applog: AppLogComponent;
    @Input() delId;
    @Input() oldData;
    @Input() newData;
    @Input() newDatap;
    @Input() scrId;
    @Input() modelName;
    statusVal = [{'val': 1, 'title': 'Active'}, {'val': 2, 'title': 'Inactive'}];
    categoriesVal = [{'val': 1, 'title': 'Additive Tax'}, {'val': 2, 'title': 'Other'}];
    calcMethodsVal = [{'val': 1, 'title': 'Percentage'}, {'val': 2, 'title': 'Custom Amount'}];
    taxPeriodsVal = [{'val': 1, 'title': 'Monthly'}, {'val': 2, 'title': 'Every 3 months'}];
    form: FormGroup;
    private sub: any;
    msgs: Message[] = [];

    private _editButton: any;
    private _deleteButton: any;
    private _newButton: any;
    private _printButton: any;
    private _searchButton: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private taxService: TaxService,
                private modalService: NgbModal,
                public activeModal: NgbActiveModal,
                public translate: TranslateService,
                private confirmationService: ConfirmationService,
                private messageService: MessageService) {
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata && userdata.lang) {
            this.translate.use(userdata.lang);
        }
        this.sharedservice.setTitle(this.route.snapshot.data.title);
        this.sharedservice.setItemShow(TaxesShowComponent);

        this.sharedservice.setButtons([
            {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton'},
            {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton'},
            // {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton'},
            {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton'},
            {label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton'},
        ]);
        this.sharedservice.setModelName('taxes');
        this.modelName = this.sharedservice.getModelName();
    }

    ngAfterViewInit() {
      if(!this.scrId && !this.oldData) {
        this._editButton = document.getElementById('editButton');
        this._deleteButton = document.getElementById('deleteButton');
        this._newButton = document.getElementById('newButton');
        this._printButton = document.getElementById('printButton');
        this._searchButton = document.getElementById('searchButton');

        if (this._editButton) {
          this._editButton.onclick = ((e: any) => {
            e.preventDefault();
            this.router.navigate(['/taxes/edit', this.id]);
          });
        }
        if (this._deleteButton) {
          this._deleteButton.onclick = ((e: any) => {
            e.preventDefault();
            this.deleteTax(this.tax);
          });
        }
        if (this._newButton) {
          this._newButton.onclick = ((e: any) => {
            e.preventDefault();
            this.router.navigate(['/taxes']);
          });
        }
        if (this._searchButton) {
          this._searchButton.onclick = ((e: any) => {
            e.preventDefault();
            this.router.navigate(['/taxes/search']);
          });

        }
      }
    }

    recordData() {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                // this.changePicUrl();
                return true;
            }
        };
        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.tax;
        modalRef.componentInstance.rowId = '';

    }

    ngOnInit() {

        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
        });

      var x = localStorage.getItem('showMessages');
      var st = localStorage.getItem('statusMessages');
      if(st == "" && x !=""){st="error";}
      if(x!= "" && x != null){

        this.msgs = [];
        this.msgs.push({severity: st, summary: '', detail: this.translate.instant(x)});
      }
      localStorage.removeItem('showMessages');
      localStorage.removeItem('statusMessages');

        this.form = new FormGroup({
            id: new FormControl({value: '', disabled: true}),
            name: new FormControl({value: '', disabled: true}),
            category: new FormControl({value: '', disabled: true}),
            calc_method: new FormControl({value: '', disabled: true}),
            tax_amount: new FormControl({value: '', disabled: true}),
            from_date: new FormControl({value: '', disabled: true}),
            to_date: new FormControl({value: '', disabled: true}),
            max_free: new FormControl({value: '', disabled: true}),
            tax_period: new FormControl({value: '', disabled: true}),
            status: new FormControl({value: '', disabled: true})

        });

        if (this.id) {
            this.activeModal.dismiss('');
            this.oldData = false;
            this.newData = false;
            this.delId = false;
            this.newDatap = true;

            localStorage.removeItem('filter');
            const msg = JSON.parse(localStorage.getItem('showMessages'));
            if (msg) {
                localStorage.removeItem('showMessages');
                this.msgs = msg;
                this.msgs= [];
            }
            this.taxService.getById(this.id).subscribe(
                tax => {
                    this.id = tax.id;
                    this.tax = tax;
                    this.form.patchValue({
                        id: tax.id,
                        name: tax.name,
                        category: tax.category,
                        calc_method: tax.calc_method,
                        tax_amount: parseFloat(tax.tax_amount),
                        from_date: tax.from_date,
                        to_date: tax.to_date,
                        max_free: tax.max_free,
                        tax_period: tax.tax_period,

                        status: tax.status,
                    });
                }, error => {
                    console.log(error);
                }
            );


        }
        if (this.delId) {
            this.oldData = false;
            this.newData = false;
            this.newDatap = !this.newDatap ;
            this.taxService.getTrashedById(this.delId).subscribe(
                tax => {
                    this.id = tax.id;
                    this.tax = tax;
                    this.form.patchValue({
                        id: tax.id,
                        name: tax.name,
                        category: tax.category,
                        calc_method: tax.calc_method,
                        tax_amount: tax.tax_amount,
                        from_date: tax.from_date,
                        to_date: tax.to_date,
                        max_free: tax.max_free,
                        tax_period: tax.tax_period,

                        status: tax.status,
                    });
                }, error => {
                    console.log(error);
                }
            );
        }

        if(this.scrId) {
            this.oldData = false;
            this.newData = false;
            this.delId = false;
            this.taxService.getById(this.scrId).subscribe(
                tax => {
                    this.id = tax.id;
                    this.tax = tax;
                    this.form.patchValue({
                        id: tax.id,
                        name: tax.name,
                        category: tax.category,
                        calc_method: tax.calc_method,
                        tax_amount: tax.tax_amount,
                        from_date: tax.from_date,
                        to_date: tax.to_date,
                        max_free: tax.max_free,
                        tax_period: tax.tax_period,
                        status: tax.status,
                    });
                }, error => {
                    console.log(error);
                }
            );
        }

        if (this.oldData && this.newData) {
            this.tax = this.newData;
            this.form.patchValue({
                id: this.newData.id,
                name: this.newData.name,
                category: this.newData.category,
                calc_method: this.newData.calc_method,
                tax_amount: this.newData.tax_amount,
                from_date: this.newData.from_date,
                to_date: this.newData.to_date,
                max_free: this.newData.max_free,
                tax_period: this.newData.tax_period,
                status: this.newData.status,
            });
        }
    }

    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if (userRoles.indexOf('setting.taxes.' + role) >= 0) {
            return true;
        }
        return false;
    }

    deleteTax(tax: Tax) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Delete'),
            message: this.translate.instant('Are you sure of delete ?'),
            icon: 'fa fa-trash',
            accept: () => {
                if (tax) {
                    this.taxService.delete(tax.id).subscribe(
                        res => {
                            console.log(res);
                            this.msgs = [];
                            if(res.result == false){
                                this.msgs.push({
                                    severity: 'error',
                                    summary: '',
                                    detail: this.translate.instant(res.message)
                                });
                            }else{
                                this.msgs.push({
                                    severity: 'success',
                                    summary: '',
                                    detail: this.translate.instant('Delete completed')
                                });
                                setTimeout(() => {
                                    this.router.navigate(['/taxes/list']);
                                },1000);
                            }
                            localStorage.setItem('showMessages', JSON.stringify(this.msgs));
                            window.scroll(0,0);
                        }
                    );
                }
            }
        });
    }

    recoverEdit(tax: Tax) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if (tax) {
                    this.taxService.update(tax).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');
                            this.router.navigate(['/taxes/show', tax.id]);
                        }
                    );
                }
            }
        });
    }

    undotrashed() {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if (this.delId) {
                    this.taxService.restoreTrashedById(this.delId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted item recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/taxes/list']);
                        }
                    );
                }
            }
        });
    }


  showattachement(row_id: string) {
    if (row_id) {
      const options: NgbModalOptions = {

        beforeDismiss: () => {
          // this.changePicUrl();
          return true;
        }
      };
      const modalRef = this.modalService.open(AppArcComponent, options);
      modalRef.componentInstance.rowId = row_id;
      modalRef.componentInstance.screenName = this.modelName;
    }
  }
  showHistory(row_id: string) {
    if (row_id) {
        const modalRef = this.modalService.open(AppLogComponent);
        modalRef.componentInstance.rowId = row_id;
        modalRef.componentInstance.refShow = TaxesShowComponent;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/views/setting/taxes/taxes-show/taxes-show.component.ts